(function () {
    'use strict';

    a3_cabin_reports.directive('passengerEvents', passengerEvents);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name passengerEvents
    * @restrict E
    * @description
    *   Implementation of passengerEvents
    * @example
    *   Usage:
    *   <passenger-events></passenger-events>
    * @ngInject
    */
    function passengerEvents(ToolkitFactory, CustomerEventFactory) {
        function link(scope) {
            
            var Passengers = [];

            //Get all OneStopShop customer events of this flight
            var customerEvents = CustomerEventFactory.groupFlightCustomerEventsByPassenger(scope.flightId);

            ToolkitFactory.getToolkitItemsFromStorage(function(toolKitItems){
                //Merge each event with its toolkit Item
                customerEvents.forEach(function(customerEvent){
                    customerEvent.OneStopShopEvents.forEach(function(event){
                        event.ToolkitItem = toolKitItems.find(x => x.Id == event.ToolkitItemId);
                        event.Treatment = toolKitItems.find(x => x.Id == event.ToolkitItemId).Treatments.find(t => t.Id == event.TreatmentId);
                    });
                });

                // OneStopShopEvent Passengers
                customerEvents.forEach(function(customerEvent){
                    //Passenger already exists - Only add events
                    if(Passengers.map(p => p.UCI).includes(customerEvent.UCI)){
                        Passengers.find(p => p.UCI == customerEvent.UCI).OneStopShopEvents = customerEvent.OneStopShopEvents;
                    }
                    //Add Passenger Info & Events
                    else{
                        var passenger = {
                            UCI: customerEvent.UCI,
                            GivenName: customerEvent.GivenName,
                            Surname: customerEvent.Surname,
                            SeatNo: customerEvent.SeatNo,
                            OneStopShopEvents : customerEvent.OneStopShopEvents,
                            numberOfEvents: customerEvent.OneStopShopEvents.length,
                            isOpen: false
                        };

                        Passengers.push(passenger);
                    }
                });

                scope.Passengers = Passengers;
            });
            
        }
        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/Flight/passengerEvents.tpl.html',
            scope: false,
            link: link
        }
    }

})();
